import React from 'react';
import {
  BackupTable,
  ManageAccounts,
  Adjust,
  Wifi,
  NoteAdd
} from '@mui/icons-material';
import Strings from '../i18n';

export const modules: {
  id: number;
  name: string;
  path: string;
  icon: React.ReactNode;
  key?: string;
}[] = [];

export const modulesWithLocation = [
  {
    id: 101,
    name: Strings.devices.devices,
    path: 'devices',
    icon: <Adjust />
  },
  {
    id: 102,
    name: Strings.users.users,
    path: 'users',
    icon: <ManageAccounts />
  },
  {
    id: 107,
    name: Strings.accessPoints.accessPoints,
    path: 'applications/access_points',
    icon: <Wifi />
  },
  {
    id: 108,
    name: Strings.applications.pageTitle,
    path: 'applications',
    icon: <BackupTable />
  },
  {
    id: 109,
    name: Strings.locations.notes.locationNotes,
    path: 'location_notes',
    icon: <NoteAdd />
  }
];
